<template>
    <div class="ku-apply">
        <h1>提交成功</h1>
        <div>
            <van-button block type="warning" class="ku-button" @click="onHome">审核中，预计1-3个工作日</van-button>
            <van-button type="warning" class="ku-button ku-button-1" @click="onSubmit">继续申请新店</van-button>
            <div class="ku-button-2" @click="onHome">返回首页</div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue';
import { Field, Button, Dialog, Uploader } from 'vant';

Vue.use(Field)
    .use(Button)
    .use(Dialog)
    .use(Uploader);

export default {
    name: "Login",
    components: {},
    data() {
        return {}
    },
    mounted() {

    },
    methods: {
        onHome() {
            this.$router.push('/')
        },
        onSubmit() {
            this.$router.push('/apply')
        }
    },
}
</script>

<style scoped lang="less">
.ku-apply {
  height: 100%;
  width: 84%;
  padding: 30px 8%;
  position: fixed;
  background: #50AFA7;

  h1 {
    text-align: center;
    color: #fff;
    letter-spacing: 20px;
    margin-top: 40%;
  }

  .ku-button {
    background: #168643;
    height: 100px;
    font-size: 32px;
    border: 2px solid #fff;
  }

  .ku-button-1 {
    margin-top: 80px;
    background: #DD5A27;
    height: 100px;
    font-size: 32px;
    border: 2px solid #fff;
  }

  .ku-button-2 {
    margin-top: 30px;
    color: #FFF;
    height: 50px;
    font-size: 32px;
    line-height: 50px;
  }
}
</style>
